import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(4),
  textAlign: 'center',
}));

export const Logo = styled('img')(({ theme }) => ({
  width: 200,
  marginBottom: theme.spacing(8),
  [theme.breakpoints.up('md')]: {
    width: 248,
    marginBottom: theme.spacing(10),
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 400,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: 500,
  },
}));

export const ButtonWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  width: '100%',
}));
